import { Component, Input } from '@angular/core';

@Component({
    selector: 'sb-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    standalone: false
})
export class LoadingComponent {

  @Input() hasLoaded: boolean;
  @Input() loadFailureMessage: string;
  @Input() message: string;

}
